/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   ใบเบิกวัตถุดิบ — หน้ารายการ
============================================================ */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card, Collapse, Form, Flex, Row, Col, Space, Select, Input, Button,
  Table, Typography, DatePicker, message,
} from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import dayjs from "dayjs";

import { accessColumn, RQ_STATUS } from "./model";
import useAccessPageState from "../../../hooks/useAccessPageState";
import RequisitionService from "../../../service/ERP/Requisition.service";

const rqService = RequisitionService();
const { RangePicker } = DatePicker;

const RequisitionAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [rows, setRows] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const run = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      if (data.rqdate?.length === 2) {
        data.rqdate_from = dayjs(data.rqdate[0]).format("YYYY-MM-DD");
        data.rqdate_to = dayjs(data.rqdate[1]).format("YYYY-MM-DD");
      }
      delete data.rqdate;
      rqService
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => setRows(res.data?.data || []))
        .catch(() => message.error("Request error!"));
    };
    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      run(forcedValues);
      return;
    }
    form.validateFields().then(run);
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    handleSearch({}, restoreDefaultPagination());
  };

  const go = (action, r) =>
    navigate(`manage/${action}`, {
      state: {
        config: {
          action,
          code: r?.rqcode || null,
          title:
            action === "create"
              ? "สร้างใบเบิกวัตถุดิบ"
              : action === "edit"
              ? "แก้ไขใบเบิกวัตถุดิบ"
              : "ใบเบิกวัตถุดิบ",
        },
      },
    });

  const handleCancel = (r) =>
    rqService
      .cancel(r.rqcode)
      .then(() => {
        message.success("ยกเลิกใบเบิกแล้ว");
        handleSearch();
      })
      .catch((err) => message.error(err?.response?.data?.message || "ยกเลิกไม่สำเร็จ"));

  useEffect(() => {
    const restored = restoreState();
    handleSearch(restored?.searchValues ?? null, restored?.tablePagination);
  }, []);

  const FormSearch = (
    <Collapse
      size="small"
      bordered={false}
      activeKey={activeSearch}
      onChange={setActiveSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined /> <span>ค้นหา</span>
            </>
          ),
          children: (
            <Form form={form} layout="vertical" autoComplete="off">
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="เลขที่ใบเบิก" name="rqcode">
                    <Input size="large" placeholder="RQ..." allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="Production Order" name="pdcode">
                    <Input size="large" placeholder="PD..." allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="วันที่เบิก" name="rqdate">
                    <RangePicker size="large" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="สถานะ" name="doc_status">
                    <Select
                      size="large"
                      allowClear
                      placeholder="ทั้งหมด"
                      options={RQ_STATUS.map((s) => ({ value: s, label: s }))}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Flex justify="end" gap={8}>
                <Button type="primary" size="small" className="bn-action" icon={<SearchOutlined />} onClick={() => handleSearch()}>
                  ค้นหา
                </Button>
                <Button type="primary" size="small" className="bn-action" danger icon={<ClearOutlined />} onClick={handleClear}>
                  ล้าง
                </Button>
              </Flex>
            </Form>
          ),
        },
      ]}
    />
  );

  return (
    <Space direction="vertical" size="middle" style={{ display: "flex" }}>
      {FormSearch}
      <Card>
        <Flex justify="space-between" align="center" className="mb-3">
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            ใบเบิกวัตถุดิบ
          </Typography.Title>
          <Button
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: "1.2rem" }} />}
            onClick={() => go("create")}
          >
            สร้างใบเบิก
          </Button>
        </Flex>
        <Table
          size="small"
          rowKey="rqcode"
          columns={accessColumn({
            handleView: (r) => go("view", r),
            handleEdit: (r) => go("edit", r),
            handleCancel,
          })}
          dataSource={rows}
          scroll={{ x: "max-content" }}
          pagination={tablePagination}
          onChange={handleTableChange}
        />
      </Card>
    </Space>
  );
};

export default RequisitionAccess;
